import { useContext } from 'react'
import AccountContext from 'app/contexts/AccountContext'
const useAccount = () => useContext(AccountContext)

export default useAccount
